import { camelCase } from 'lodash'

import { generateServices, getServiceComponent, globalErrorHandler, states } from '@/utils'

import render from './render'

export default function(options = {}) {
  return {
    name: 'CreateButton',

    mixins: [
      generateServices({
        name: options.name,

        inputFilter: options.inputFilterForCreateButton,
        outputFilter: options.outputFilterForCreateButton,

        create: {
          redirect: true,
          params: {
            query: {
              $scope: [ 'full' ]
            }
          }
        },

        find: false,
        get: false,
        update: false,
        remove: false
      })
    ],

    components: {
      [`${camelCase(`${options.name}-form`)}`]: getServiceComponent(`${options.name}/form`)
    },

    props: {
      maxWidth: {
        type: Number,
        default: 800
      },
      type: {
        type: String,
        default: 'list-item'
      },
      title: {
        type: String,
        default: undefined
      }
    },

    data() {
      return {
        titleIsValid: true,

        showDialog: false
      }
    },

    computed: {
      createDataIsValid() {
        return (
          this.restData[options.name].create.state !== states.loading &&
          this.restData[options.name].create.isValid &&
          this.titleIsValid
        )
      }
    },

    methods: {
      async createData() {
        if (this.createDataIsValid) {
          try {
            const result = await this.rest[options.name].create(this.restData[options.name].create.data)
            if (result) {
              this.show = false
            }
          } catch (error) {
            globalErrorHandler(error)
          }
        }
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
